/*
export default function useUserConfigTable() {
  return [
    // { label: "Data inserimento", 
    //   key: "data_inserimento",
    //   width: "80px",
    //   formatter: (value) => {
    //     if (!value) return '';
    //     const date = new Date(value);
    //     const pad = (n) => n.toString().padStart(2, '0');
    //     const giorno = pad(date.getDate());
    //     const mese = pad(date.getMonth() + 1);
    //     const anno = date.getFullYear();
    //     // const ore = pad(date.getHours());
    //     // const minuti = pad(date.getMinutes());
    //     //return `${giorno}/${mese}/${anno} ore ${ore}:${minuti}`;
    //     return `${giorno}/${mese}/${anno}`;
    //   }
    // },
    // { label: "Data ultima iscrizione", 
    //   key: "ultima_data_iscrizione_corso",
    //   width: "100px",
    //   formatter: (value) => {
    //     if (!value) return '';
    //     const date = new Date(value);
    //     const pad = (n) => n.toString().padStart(2, '0');
    //     const giorno = pad(date.getDate());
    //     const mese = pad(date.getMonth() + 1);
    //     const anno = date.getFullYear();
    //     // const ore = pad(date.getHours());
    //     // const minuti = pad(date.getMinutes());
    //     //return `${giorno}/${mese}/${anno} ore ${ore}:${minuti}`;
    //     return `${giorno}/${mese}/${anno}`;
    //   }
    // },
    { label: "Cognome", key: "cognome", width: "200px" },
    { label: "Nome", key: "nome", width: "200px" },
    { label: "Ruolo", key: "tipo_utente", width: "120px" },
    { label: "Email", key: "username" },
    { 
      label: "Stato", 
      key: "abilitato_web",
      formatter: (value) => value == "1" ? "Attivo" : "In attesa" 
    },
  ];
}
*/

export default function useUserConfigTable() {
  return [
    { label: "Cognome", key: "cognome", width: "200px" },
    { label: "Nome", key: "nome", width: "200px" },
    // --- NUOVA COLONNA "AGENZIA" AGGIUNTA QUI ---
    { 
      label: "Agenzia", 
      key: "agenzia",
      hideOrder: true, // Generalmente non si ordina per questo campo
      formatter: (value, row) => {
        // La proprietà 'agenzia' viene dal LEFT JOIN che abbiamo fatto nel backend.
        // Se l'utente ha un'agenzia, mostra il nome, altrimenti un trattino.
        return row.agenzia ? row.agenzia : '-';
      }
    },
    // ------------------------------------------
    { label: "Ruolo", key: "tipo_utente", width: "120px" },
    { label: "Email", key: "username" },
    { 
      label: "Stato", 
      key: "abilitato_web",
      formatter: (value) => value == "1" ? "Attivo" : "In attesa" 
    },
  ];
}